import React, { useState, useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { IMG_LOGO, IMG_FOUR_O_FOUR, IMG_MOON, IMG_ARROW } from "../../config";
import { useNavigate } from "react-router-dom";
import { Button } from "../../ds2/components";
import { useSelector } from "react-redux";

import "../../index.css";
import "./ErrorPage.css";

import config from "environment";
import { selectUser } from "../../redux/features/appData";

export default function ErrorPage() {
  const navigate = useNavigate();
  const userId = useSelector(selectUser)?.id;

  const [isReadOnly] = useState<boolean>(false);

  const error = useRouteError() as any;
  console.error(error);

  useEffect(() => {
    if (userId) {
      // setIsReadOnly(false);
    }
  }, []);

  const handleHome = () => {
    if (isReadOnly) {
      window.location.href = "https://usewinslow.com";
      return;
    }

    navigate("/");
  };

  return (
    <div id="error-page" className={config.theme}>
      <div className="error-page-header">
        <a href="https://usewinslow.com">
          <div className="error-page-logo">
            <img
              src={IMG_LOGO}
              style={{ width: "40px", height: "40px" }}
              alt="Winslow logo"
            />
            <span className="error-page-company-name">Winslow</span>
          </div>
        </a>

        <div className="error-page-signup">
          {isReadOnly && (
            <>
              <Button
                variant="primary"
                onClick={() => {
                  navigate("/login");
                }}>
                Sign In
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  navigate("/signup");
                }}>
                Sign Up for Free
              </Button>
              
              {/* <button
                onClick={() => {
                  navigate("/login");
                }}
                style={{ backgroundColor: "var(--button-color-secondary)" }}>
                Sign In
              </button>
              <button
                onClick={() => {
                  navigate("/signup");
                }}>
                Sign Up for Free
              </button> */}
            </>
          )}
        </div>
      </div>

      <div className="error-page-body">
        {/* <img
          src={IMG_FOUR_O_FOUR}
          className="error-page-body-404"
          alt="404 error illustration"
        /> */}
        <span style={{fontSize: "96px", fontWeight: 600}}>404</span>
        <div className="error-page-text">
          The page you are looking for is lost in space.
          <br />
          You don’t have to be, just go home.
        </div>
        <Button
          variant="secondary"
          onClick={handleHome}
        >
          Go Home
        </Button>
        
        {/* <button onClick={handleHome}>Go Home</button> */}

        {/* <div className="error-page-body-arrow">
          <img src={IMG_ARROW} alt="Arrow pointing to home button" />
        </div> */}

        <div className="error-page-error" style={{color: "var(--text-color-tertiary)"}}>
          Error: {error.statusText || error.message}
        </div>
      </div>

     

      {/* <div className="error-page-moon">
        <img
          src={IMG_MOON}
          style={{ height: "400px" }}
          alt="Moon illustration"
        />
      </div> */}
    </div>
  );
}
